import { createContext, useContext } from "react";

/**
 * True inside a desktop dock module (`PanelFrame`). There the window shows the trading state, the
 * account picker and the 1-click / hotkeys tags once (status line), and a module's own options live
 * in its header "⋯" menu (`ModuleMenu`); outside a dock (the mobile Trade tab) the order surfaces
 * keep them inline.
 */
export const InDockContext = createContext(false);

export function useInDock(): boolean {
  return useContext(InDockContext);
}
